// Maps Shopify colour-option names to swatch hex values.
// Shared by the product viewer's variant swatches and the shop's colour filter
// so both stay in sync.
const COLOR_MAP = {
  'black': '#151515',
  'white': '#FFFFFF',
  'off white': '#FEF8E1',
  'cream': '#f5f0e1',
  'beige': '#d4c5a9',
  'red': '#8A0106',
  'blue': '#1565c0',
  'light blue': '#64b5f6',
  'baby blue': '#BFE5FF',
  'navy': '#000A1A',
  'navy blue': '#000A1A',
  'green': '#083717',
  'bottle green': '#083717',
  'sage green': '#8fbc8f',
  'olive': '#6b6b3a',
  'olive green': '#6b6b3a',
  'jade': '#A4C9A3',
  'mint': '#98ff98',
  'grey': '#757575',
  'gray': '#757575',
  'charcoal': '#36454f',
  'pink': '#e91e63',
  'light pink': '#f8bbd0',
  'light baby pink': '#FFD4E9',
  'flamingo': '#EDA8B5',
  'baby pink': '#f4c2c2',
  'hot pink': '#ff69b4',
  'dusty pink': '#d4a5a5',
  'dusty rose': '#c4767a',
  'rose': '#c4767a',
  'lavender': '#E5DBFF',
  'lilac': '#c8a2c8',
  'purple': '#7b1fa2',
  'yellow': '#f9a825',
  'mustard': '#c8a415',
  'orange': '#ef6c00',
  'brown': '#5d4037',
  'maroon': '#31050C',
  'burgundy': '#800020',
  'teal': '#00796b',
  'coral': '#ff7f50',
  'peach': '#ffcba4',
  'sand': '#c2b280',
  'khaki': '#c3b091',
  'tan': '#d2b48c',
};

export function getColorHex(colorName) {
  return COLOR_MAP[colorName.toLowerCase()] || '#888';
}

// Colours pinned to the front of filter menus, in this order; the rest stay alphabetical.
const COLOR_ORDER = ['off white', 'black'];

export function sortColors(colors) {
  return [...colors].sort((a, b) => {
    const ai = COLOR_ORDER.indexOf(a.toLowerCase());
    const bi = COLOR_ORDER.indexOf(b.toLowerCase());
    if (ai !== -1 || bi !== -1) {
      return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
    }
    return a.localeCompare(b);
  });
}

export { COLOR_MAP };
